import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../shared/services/toastr.service';
import { WidgetState } from '../../state/widget_state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { DropDownOption } from '../../../../shared/models/dropdown_option';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { widgetToggleAutoPublish, widgetUpdate } from '../../state/widget_actions';
import { IAppState } from '../../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yi-widget-setup',
  template: require('./widget_setup.component.html'),
  styles: [require('./widget_setup.component.scss')]
})
export class WidgetSetupComponent implements OnInit, OnDestroy {
  private autoPublishOnMsg: string;
  private autoPublishOffMsg: string;
  private widgetState: WidgetState;
  // @ts-ignore
  private isWidgetV3: boolean;
  private fontInput = '';
  private primaryColorInput = '';
  private starsColorInput = '';
  private subscription: Subscription;
  fontOptions: Array<any>;
  autoPublish: boolean;

  constructor(private translateService: TranslateService,
              private toastrService: ToastService,
              private redCrossService: AnalyticsTrackingProvider,
              private store: Store<IAppState>) {
    this.translateService.stream('WIDGET.WIDGET_FONTS').subscribe((translations) => {
      this.fontOptions = [
        new DropDownOption<string>(translations['OPEN_SANS']),
        new DropDownOption<string>(translations['VERDANA']),
        new DropDownOption<string>(translations['ARIAL']),
        new DropDownOption<string>(translations['TAHOMA']),
        new DropDownOption<string>(translations['DAVID'])
      ];
    });
    this.translateService.stream('WIDGET.TOGGLE').subscribe(
      (translated) => {
        this.autoPublishOnMsg = translated['TURNED_ON'];
        this.autoPublishOffMsg = translated['TURNED_OFF'];
      });

    this.subscription = this.store.select(state => state.app.install.widget).subscribe((data: WidgetState) => {
      this.widgetState = data;
    });

    this.store.select(state => state.app.install.integrate.hasWidgetV3).pipe(take(1)).subscribe(
      (hasWidgetV3: boolean) => {
        this.isWidgetV3 = hasWidgetV3;
      });
  }

  ngOnInit() {
    this.fontInput = this.widgetState.font;
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, {pageCategory: 'Installation V2'});
    this.redCrossService.page(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step 2',
      phase: 2,
      status: 'started',
    });
    this.redCrossService.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.CUSTOMIZE_WIDGET,
      stepNum: 2,
      status: REDCRSS_EVENTS.STARTED,
      isWidgetV3: this.isWidgetV3
    });
    this.updatePreview();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onUpdateFont() {
    this.widgetState = {...this.widgetState, font: this.fontInput, fontChanged: true};
    this.updatePreview();
  }

  onUpdatePrimaryColor(color: string) {
    this.primaryColorInput = color;
    if (this.validateColor(this.primaryColorInput)) {
      this.widgetState = {...this.widgetState, primaryColor: this.primaryColorInput, primaryColorChanged: true};
    }
    this.updatePreview();
  }

  onUpdateStarsColor(color: string) {
    this.starsColorInput = color;
    if (this.validateColor(this.starsColorInput)) {
      this.widgetState = {...this.widgetState, starRatingColor: this.starsColorInput, starRatingColorChanged: true};
    }
    this.updatePreview();
  }

  updatePreview() {
    this.store.dispatch(widgetUpdate({payload: this.widgetState}));
  }

  onSwitchToggle(enabled) {
    if (!enabled) {
      this.store.dispatch(widgetToggleAutoPublish({autoPublish: false}));
      this.redCrossService.track('Feature Disabled', {feature: 'Auto Publish'});
      this.toastrService.errorNoTitle(this.autoPublishOffMsg);
    } else {
      this.store.dispatch(widgetToggleAutoPublish({autoPublish: true}));
      this.redCrossService.track('Feature Enabled', {feature: 'Auto Publish'});
      this.toastrService.success(this.autoPublishOnMsg);
    }
  }

  private validateColor(color) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  }
}
